import React from 'react';
import { useParams } from 'react-router-dom';

import { reports } from './hooks';
import {
  AnnualDfiReport,
  ExtensionRequestsReport,
  LateResponsesReport,
  OutstandingResponsesReport,
  RespondedYearToDateReport,
} from './components';
import { RespondedOnTimeReport } from './components/reports/RespondedOnTimeReport';
import { useThemedValueSwitch } from '@tq/ui-components';

export const Report: React.FC = () => {
  const { name } = useParams();
  const { isTQ } = useThemedValueSwitch();

  const annualOrDfiReport = isTQ ? reports.annualReport : reports.annualDfi;

  switch (name) {
    case annualOrDfiReport:
      return <AnnualDfiReport />;
    case reports.extensionRequests:
      return <ExtensionRequestsReport />;
    case reports.lateResponses:
      return <LateResponsesReport />;
    case reports.outstandingResponses:
      return <OutstandingResponsesReport />;
    case reports.respondedOnTime:
      return <RespondedOnTimeReport />;
    case reports.respondedYearToDate:
      return <RespondedYearToDateReport />;
    default:
      return <></>;
  }
};
